import React from 'react';
import PhenoScanSubTab, { StatCard } from './PhenoScanSubTab';

export default function Seed() {
  return (
    <PhenoScanSubTab
      testIdPrefix="seed"
      analyzeEndpoint="/phenoscan/seed/analyze"
      sampleEndpoint="/phenoscan/seed/sample"
      sampleMetaEndpoint="/phenoscan/seed/sample-meta"
      exportKey="seed"
      title="Seed & Fruit"
      gtFormField="ground_truth_count"
      extraParams={{ per_image_mass_g: '' }}
      renderResult={renderResult}
      traitExtractor={(r) => r ? ({
        source: 'phenoscan_seed',
        traits: {
          count: r.count,
          defect_count: r.defect_count,
          defect_rate_pct: r.defect_rate_pct,
          mean_area_mm2: r.distribution_area?.mean,
          CV_area_pct: r.distribution_area?.cv_percent,
          mean_length_mm: r.distribution_length?.mean,
          mean_roundness: r.distribution_roundness?.mean,
          thousand_seed_weight_g: r.test_weight?.thousand_seed_weight_g,
        },
      }) : null}
    />
  );
}

function renderResult(r) {
  const d = r.distribution_area || {}; const dl = r.distribution_length || {};
  const dr = r.distribution_roundness || {}; const tw = r.test_weight || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <StatCard title="Count & Defects" rows={[
        ['Seed count', r.count],
        ['Defect count', r.defect_count],
        ['Defect rate (%)', r.defect_rate_pct],
        ['Uniformity CV (area %)', r.uniformity_index_cv_pct],
      ]} />
      <StatCard title="Area distribution" rows={[
        ['Mean', d.mean], ['SD', d.sd], ['CV %', d.cv_percent],
        ['Min', d.min], ['Max', d.max], ['n', d.n],
      ]} />
      <StatCard title="Length / Roundness" rows={[
        ['Mean length', dl.mean], ['CV length %', dl.cv_percent],
        ['Mean roundness', dr.mean], ['SD roundness', dr.sd],
      ]} />
      {tw.thousand_seed_weight_g != null && (
        <StatCard title="Test weight" rows={[
          ['Image mass (g)', tw.per_image_mass_g],
          ['Count in image', tw.count_in_image],
          ['1000-seed weight (g)', tw.thousand_seed_weight_g],
        ]} />
      )}
      <StatCard title="Method" rows={Object.entries(r.method || {})} />
    </div>
  );
}
